// import { BaseResponse } from 'app/models/dom';
import { OpenNewTicketRequest } from '../models/ss-api/requests/open.new.ticket.request'; // /requests/OpenNewTicketRequest
import { TicketMessageItem } from '../models/domain/ticket.message.item';
import { TicketDetailsDialog } from '../dialogs/ticket.details/ticket.details.dialog';
import { UpdateTicketRequest } from '../models/ss-api/requests/update.ticket.request';
import { AppModule } from '../app.module';
import { TicketService } from '../services/ticket.service';
import { TicketLogItemArray } from '../models/domain/ticket.log.item';
import { AddTicketReplyRequest } from '../models/ss-api/requests/add.ticket.reply.request';
import { TicketItem } from '../models/domain/ticket.item';
import { Subscription } from 'rxjs';
import { ManagerBase } from './manager.base';
import { Subject } from 'rxjs/Subject';
import { BaseResponse } from '../models/comm-http/responses/BaseResponse';
import { TicketAssignMemberRequest } from '../models/ss-api/requests/ticket.assign.member.request';

export enum MessageSourceTypes {
    Me = 0,
    Admin = 1,
    Member = 2
}

export class OnTicketMemberAssignedArgs {
    public MemberID: number;
    public Name: string;

    constructor(memberId: number, memberFullName: string) {
        this.MemberID = memberId;
        this.Name = memberFullName;
    }
}

export class TicketManager extends ManagerBase<TicketItem> {

    public Busy: boolean = false;

    public OnBusyChanged = new Subject<boolean>();
    public OnTicketLoaded = new Subject<TicketItem>();
    public OnTicketOpenNewOK = new Subject<TicketItem>();
    public OnTicketOpenNewError = new Subject();
    public OnTicketOpenNewCancel = new Subject();
    public OnTicketReplyAdd = new Subject<AddTicketReplyRequest>();
    public OnTicketReplyAddError = new Subject<AddTicketReplyRequest>();
    public OnTicketReplyAddCancel = new Subject<AddTicketReplyRequest>();
    public OnTicketMemberAssigned = new Subject<OnTicketMemberAssignedArgs>();
    public OnTicketMemberUnassign = new Subject<number>(); // ticketid
    public OnTicketLogs = new Subject<TicketLogItemArray>();


    public TicketReplySuccessFullMessage = 'Ticket reply successful';
    public TicketReplyMessageShowTimer = 800; // in miliseconds
    public AddMode: boolean = false;

    // subscriptions
    private liveMemberAssign: Subscription;
    private liveMemberUnassigned: Subscription;
    private ssdb2TicketLogs: Subscription;

    // service
    private ticketingService: TicketService = AppModule.injector.get(TicketService);


    constructor(id: number = 0, showAfterLoad: boolean = true, ticketNumber: string = '') {
        super();
        this.onDestroy = this.Destroy; // callback
        this.subsribe();

        if (id != 0 && ticketNumber == '')
            this.Load(id, showAfterLoad);
        else if (id == 0 && ticketNumber != '')
            this.LoadByTicketNr(ticketNumber, showAfterLoad);
        else if (id == 0 && ticketNumber == '') {
            // add mode

        }

    }

    public SetAddMode(adminID: number, name: string, subject: string, memberID: number = -1, memberName: string = '') {

        this.newEntity = new TicketItem();
        this.newEntity.TicketNR = '(new)';
        this.newEntity.Name = name;
        this.newEntity.AdminID = adminID;
        this.newEntity.Subject = subject;
        this.newEntity.MemberID = memberID;
        this.newEntity.MemberName = memberName;

        this.CloneToOriginal();


        this.AddMode = true;
        this.DialogAction = this.dialogService.addDialog(TicketDetailsDialog, {
            // ticketManager: this,
        })

    }

    private subsribe() {

        this.ssdb2TicketLogs = this.api.onTicketLogByID.subscribe((response) => {
            let data = response.Data;
            this.newEntity.Logs = data;
            this.original.Logs = data;
            this.OnTicketLogs.next(data);
        })

    }



    private Destroy() {
        this.liveMemberAssign.unsubscribe();
        this.liveMemberAssign.unsubscribe();
        this.ssdb2TicketLogs.unsubscribe();
    }


    public Ticket(): TicketItem {
        return this.newEntity;
    }


    public AdminEdited(): boolean {
        return this.original.AdminID != this.newEntity.AdminID;
    }

    public DepartmentEdited(): boolean {
        return this.original.DepartmentID != this.newEntity.DepartmentID;
    }

    public StatusEdited(): boolean {
        return this.original.Status != this.newEntity.Status;
    }


    public Edited(): boolean {

        if (this.AdminEdited())
            return true;

        if (this.DepartmentEdited())
            return true;

        if (this.StatusEdited())
            return true;


        // not edited
        return false;

    }

    public LoadLogs() {
        this.SetIsBusy(true);
        this.api.GetTicketLogs(this.Ticket().TicketID).subscribe((data) => this.SetIsBusy(false));
    }

    private ProcessAddReply(request: AddTicketReplyRequest, showResult: boolean = false): Promise<any> {

        return new Promise((resolve, reject) => {
            this.api.TicketAddReply(request).subscribe((data) => {

                if (!data.Result) {
                    // error
                    this.sweetAlertService.swal({
                        title: 'Error',
                        text: data.Message,
                        type: 'error',
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: 2000
                    })
                        .then(() => { }, () => { }); // keep this line to prevent promise error;

                    this.OnTicketReplyAddError.next(request);
                    reject();
                    this.SetIsBusy(false);
                } else {

                    // ok

                    this.sweetAlertService.swal({
                        title: 'Info',
                        text: this.TicketReplySuccessFullMessage,
                        type: 'info',
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: this.TicketReplyMessageShowTimer
                    })
                        .then(() => { }, () => { }); // keep this line to prevent promise error;

                    setTimeout(() => {
                        this.OnTicketReplyAdd.next(request);
                        this.SetIsBusy(false);
                        resolve();
                    }, this.TicketReplyMessageShowTimer)

                }
            })
        });
    }

    public AddReply(message: string, noEmail: boolean, confirm: boolean = true, status: string = '') {

        this.SetIsBusy(true);

        let request = new AddTicketReplyRequest();
        request.TicketID = this.Ticket().TicketID;
        request.Message = message;
        request.NoEmail = noEmail;
        request.Status = status;
        request.useMarkDown = false;
        request.AdminUsername = this.globalService.Username;

        if (!confirm) {
            this.ProcessAddReply(request, false);
            return;
        }


        // confirm
        this.sweetAlertService.swal({
            title: 'Are you sure to add this reply?',
            text: '',
            type: 'warning',
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: 'Yes, send!',
            cancelButtonText: 'No, cancel',
            allowOutsideClick: false,
            showLoaderOnConfirm: true,
            preConfirm: () => {
                return this.ProcessAddReply(request, true);
            },
        }).then(
            (result) => { },
            (dismiss) => {

                if (dismiss === 'cancel') {
                    this.OnTicketReplyAddCancel.next(request);
                    this.SetIsBusy(false);
                    if (!confirm)
                        return;


                }
            })

    }

    public SaveChanges(confirm: boolean = true, showResult: boolean = true) {

        if (this.Edited() == false || this.AddMode)
            return;

        let request = this.GetTicketUpdateRequest();
        this.SaveAction = this.api.TicketUpdate(request);


        this.SaveChangesBase();
    }

    public AddNewTicket(confirm: boolean = true, showResult: boolean = true) {

        let request = this.GetTicketAddRequest();

        if (!confirm) {
            this.AddNewTicketExecute(request, showResult);
            return;
        }

        // confirm
        this.sweetAlertService.swal({
            title: 'Are you sure?',
            text: 'You will create a new ticket for this admin.',
            type: 'warning',
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: 'Yes, create!',
            cancelButtonText: 'No, cancel',
            allowOutsideClick: false,
            showLoaderOnConfirm: true,
            preConfirm: () => {
                return new Promise((resolve, reject) => {
                    setTimeout(() => {
                        this.AddNewTicketExecute(request, showResult);
                        resolve();
                    }, 1000)
                })
            }
        }).then(
            () => { },

            (dismiss) => {
                if (dismiss === 'cancel') {
                    this.OnTicketOpenNewCancel.next();

                    if (!confirm)
                        return;

                    // show cancelled
                    this.sweetAlertService.swal({
                        title: 'Cancelled',
                        text: 'No changes are saved.',
                        type: 'error',
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: 1500
                    })
                        .then(() => { }, () => { }); // keep this line to prevent promise error;
                }
            })

    }

    private AddNewTicketExecute(request: OpenNewTicketRequest, showResult: boolean) {

        this.SetIsBusy(true);
        this.api.TicketOpenNew(request).subscribe(

            (result: BaseResponse<TicketItem>) => {
                if (!showResult)
                    return;

                // result
                if (result.Result) {
                    // ok
                    this.SetNewEntity(result.Data);
                    this.OnTicketOpenNewOK.next(result.Data);
                    this.sweetAlertService.swal(
                        'Created!',
                        'Your ticket is created.',
                        'success'
                    )
                        .then(() => { }, () => { }); // keep this line to prevent promise error;
                } else {
                    // error
                    this.OnTicketOpenNewError.next();
                    this.sweetAlertService.swal(
                        'Error',
                        result.Message,
                        'error'
                    )
                        .then(() => { }, () => { }); // keep this line to prevent promise error;
                }
            },

            (error: any) => {
                this.SetIsBusy(false);
                this.OnTicketOpenNewError.next();

                if (!showResult)
                    return;

                // error
                this.sweetAlertService.swal(
                    'Error',
                    'Unknown Error :-(',
                    'error'
                )
                    .then(() => { }, () => { }); // keep this line to prevent promise error;
            }


        );

    }

    public GetTicketAddRequest(): OpenNewTicketRequest {

        let request = new OpenNewTicketRequest();

        request.AdminID = this.newEntity.AdminID;
        request.DepartmentID = this.newEntity.DepartmentID;
        request.Status = this.newEntity.Status;
        request.Name = this.newEntity.Name;
        request.Message = this.newEntity.FirstMessage;
        request.Email = this.newEntity.Email;
        request.Priority = 'Medium';
        request.Subject = this.newEntity.Subject;

        return request;
    }

    private GetTicketUpdateRequest(): UpdateTicketRequest {

        let request = new UpdateTicketRequest();
        request.TicketID = this.Ticket().TicketID;

        if (this.AdminEdited())
            request.AdminID = this.newEntity.AdminID;

        if (this.DepartmentEdited())
            request.DepartmentID = this.newEntity.DepartmentID;

        if (this.StatusEdited())
            request.Status = this.newEntity.Status;

        return request;
    }


    Load(id: number, showAfterLoad: boolean = true) {

        if (id < 1)
            return;

        this.LoadAction = this.api.GetTicketsByID(id);

        let DataLoaded = this.OnDataLoaded.subscribe(() => {
            DataLoaded.unsubscribe();
            this.CloneDateFix();
            this.DialogAction = this.dialogService.addDialog(TicketDetailsDialog, {
                // ticketManager: this,
            })
        })

        this.LoadBase();
    }

    AssignMember(memberID: number, memberFullName: string) {

        let request = new TicketAssignMemberRequest();
        request.MemberID = memberID;
        request.TicketID = this.Ticket().TicketID;

        this.api.TicketAssignMember(request)
            .toPromise()
            .then((data) => {

                if (data.Result) {
                    this.original.MemberID = memberID;
                    this.newEntity.MemberID = memberID;
                    this.original.Name = memberFullName;
                    this.newEntity.Name = memberFullName;


                    this.ticketingService.TicketAssignedToMember(this.Ticket().TicketID, memberID, memberFullName);
                    let args = new OnTicketMemberAssignedArgs(memberID, memberFullName);
                    this.OnTicketMemberAssigned.next(args);
                }
            });

    }

    UnassignMember() {

        let request = new TicketAssignMemberRequest();
        request.TicketID = this.Ticket().TicketID;

        this.api.TicketUnassignFromMember(request)
            .toPromise()
            .then((data) => {

                if (data.Result) {
                    this.original.MemberID = 0;
                    this.newEntity.MemberID = 0;

                    this.OnTicketMemberUnassign.next(this.Ticket().TicketID);
                }
            });

    }

    LoadByTicketNr(ticketNr: string, showAfterLoad: boolean = true) {

        if (ticketNr == '')
            return;

        this.LoadAction = this.api.GetTicketsByNR(ticketNr);

        let DataLoaded = this.OnDataLoaded.subscribe((data) => {
            DataLoaded.unsubscribe();
            this.CloneDateFix();
            this.DialogAction = this.dialogService.addDialog(TicketDetailsDialog, {
                // ticketManager: this,
            })
        })

        this.LoadBase();
    }


    private CloneDateFix(): void {

        // dates don't convert to Date so do it manual
        this.original.DateTimeCreated = this.newEntity.DateTimeCreated;
        this.original.DateTimeLastReply = this.newEntity.DateTimeLastReply;
    }

    public GetMessageType(message: TicketMessageItem): MessageSourceTypes {
        if (this.IsMeMessage(message))
            return MessageSourceTypes.Me;
        else if (this.IsAdminMessage(message))
            return MessageSourceTypes.Admin;
        else
            return MessageSourceTypes.Member;
    }

    public IsMeMessage(message: TicketMessageItem): boolean {
        if (
            this.IsAdminMessage(message) &&
            this.globalService.FirstName + ' ' + this.globalService.LastName == message.AdminName) {
            return true;
        } else {
            return false;
        }
    }

    public IsAdminMessage(message: TicketMessageItem): boolean {
        if (message.MemberID == 0 && message.Name == message.AdminName)
            return true;
        else
            return false;
    }

    public IsMemberMessage(message: TicketMessageItem): boolean {
        if (message.MemberID == 0)
            return false;
        else
            return true;
    }

    public IsLeadMessage(message: TicketMessageItem): boolean {
        if (!this.IsAdminMessage(message) && !this.IsMemberMessage(message))
            return true;
        else
            return false;
    }

}
